import Image from 'next/image';
import { Trans } from 'react-i18next';

import { colors } from 'components/styles/variables';
import { useGeolocationData } from 'lib/hooks/useGeoLocation';
import CarCarousel from 'public/static/images/onboarding/car-carousel.png';

import { OnboardingComponentProps } from '../Modal';
import Button from '../Button';
import AutolistLogo from '../Logo';

const Welcome = ({ t, onNextStep, onGoToStep }: OnboardingComponentProps): JSX.Element => {
  const existingGeolocationData = useGeolocationData();
  const onStartClick = (): void => (existingGeolocationData ? onNextStep() : onGoToStep(2));

  return (
    <>
      <div className="welcome-container">
        <AutolistLogo />
        <div className="modal-header">
          <Trans i18nKey="onboarding.welcomeScreen.header" components={[<br />]} />
        </div>
        <div className="modal-subtext">
          <Trans i18nKey="onboarding.welcomeScreen.subText" components={[<br />]} />
        </div>
        <Image alt="car-carousel" src={CarCarousel} width={700} height={252} />
        <div className="button-container">
          <Button onClick={onStartClick}>{t('onboarding.welcomeScreen.ctaButton')}</Button>
        </div>
      </div>
      <style jsx>{`
        .welcome-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 564px;
        }
        .modal-header {
          font-size: 22px;
          font-style: normal;
          font-weight: 700;
          line-height: 32px;
          letter-spacing: 0.2px;
          margin: 0 16px 16px 16px;
          text-align: center;
        }
        .modal-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
        }
        .modal-subtext {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0.2px;
          text-align: center;
          margin: 0 0 42px 0;
        }
        .close-modal-content {
          height: 244px;
          width: 280px;
          border-radius: 8px;
          background-color: ${colors.WHITE};
          opacity: 1;
        }
        .close-modal-header {
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 22px;
          letter-spacing: 0.2px;
          margin-top: 24px;
        }
        .close-modal-subtext {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0.2px;
          margin: 12px 0 32px 0;
        }
        .autolist-logo {
          height: 36px;
          width: 36px;
        }
        .button-container {
          margin-top: 42px;
        }
      `}</style>
    </>
  );
};

export default Welcome;
